/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  APIArticle,
  APIArticleExport,
  APIArticleExportRequest,
  APIArticleRequest,
  APIHumanReadableDurationRequest,
  APIMeasurementRequest,
  APIPaginatedArticleExportList,
  APIPaginatedArticleList,
  APIPatchedArticleRequest,
  APIStorageArticle,
} from '../models/index';
import {
    APIArticleFromJSON,
    APIArticleToJSON,
    APIArticleExportFromJSON,
    APIArticleExportToJSON,
    APIArticleExportRequestFromJSON,
    APIArticleExportRequestToJSON,
    APIArticleRequestFromJSON,
    APIArticleRequestToJSON,
    APIHumanReadableDurationRequestFromJSON,
    APIHumanReadableDurationRequestToJSON,
    APIMeasurementRequestFromJSON,
    APIMeasurementRequestToJSON,
    APIPaginatedArticleExportListFromJSON,
    APIPaginatedArticleExportListToJSON,
    APIPaginatedArticleListFromJSON,
    APIPaginatedArticleListToJSON,
    APIPatchedArticleRequestFromJSON,
    APIPatchedArticleRequestToJSON,
    APIStorageArticleFromJSON,
    APIStorageArticleToJSON,
} from '../models/index';

export interface V1ItemsArticlesAnonymizedArticleCreateRequest {
    aPIArticleRequest: APIArticleRequest;
}

export interface V1ItemsArticlesBomLeafArticlesRetrieveRequest {
    id: number;
}

export interface V1ItemsArticlesBomRootRetrieveRequest {
    id: number;
}

export interface V1ItemsArticlesChildrenRetrieveRequest {
    id: number;
}

export interface V1ItemsArticlesCreateRequest {
    aPIArticleRequest: APIArticleRequest;
}

export interface V1ItemsArticlesDestroyRequest {
    id: number;
}

export interface V1ItemsArticlesListRequest {
    page?: number;
    pageSize?: number;
}

export interface V1ItemsArticlesPartialUpdateRequest {
    id: number;
    aPIPatchedArticleRequest?: APIPatchedArticleRequest;
}

export interface V1ItemsArticlesRetrieveRequest {
    id: number;
}

export interface V1ItemsArticlesStorageInfoRetrieveRequest {
    id: number;
}

export interface V1ItemsArticlesUpdateRequest {
    id: number;
    aPIArticleRequest: APIArticleRequest;
}

export interface V1ItemsExportArticlesListRequest {
    page?: number;
    pageSize?: number;
}

export interface V1ItemsImportArticlesCreateRequest {
    number: string;
    material: string;
    name?: string;
    hoopsPartId?: string;
    weight?: APIMeasurementRequest | null;
    length?: APIMeasurementRequest | null;
    width?: APIMeasurementRequest | null;
    height?: APIMeasurementRequest | null;
    volume?: APIMeasurementRequest | null;
    barcodeText?: string;
    qualityClass?: string;
    countryOfOrigin?: string;
    description?: string;
    leadTime?: APIHumanReadableDurationRequest | null;
    isBomBase?: boolean;
    isImportedVersion?: boolean;
    articleType?: string | null;
    family?: string | null;
    brand?: string | null;
    barcodeType?: string | null;
    variationOf?: string | null;
    supplier?: string | null;
    category?: Array<string | null>;
    properties?: Array<string | null>;
    guestRequest?: string | null;
    sharedRequest?: string | null;
}

export interface V1ItemsUndoImportArticlesCreateRequest {
    aPIArticleExportRequest?: APIArticleExportRequest;
}

/**
 * 
 */
export class ItemsarticlesApi extends runtime.BaseAPI {

    /**
     * Create an anonymized request article including copied files and BOM children.
     */
    async v1ItemsArticlesAnonymizedArticleCreateRaw(requestParameters: V1ItemsArticlesAnonymizedArticleCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIArticle>> {
        if (requestParameters['aPIArticleRequest'] == null) {
            throw new runtime.RequiredError(
                'aPIArticleRequest',
                'Required parameter "aPIArticleRequest" was null or undefined when calling v1ItemsArticlesAnonymizedArticleCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/items/articles/anonymized_article/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: APIArticleRequestToJSON(requestParameters['aPIArticleRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIArticleFromJSON(jsonValue));
    }

    /**
     * Create an anonymized request article including copied files and BOM children.
     */
    async v1ItemsArticlesAnonymizedArticleCreate(requestParameters: V1ItemsArticlesAnonymizedArticleCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIArticle> {
        const response = await this.v1ItemsArticlesAnonymizedArticleCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Method to fetch multiple specific instances at once. THIS METHOD SHOULD BE REPLACED AT SOME POINT!
     */
    async v1ItemsArticlesBatchRequestRetrieveRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIArticle>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/items/articles/batch_request/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIArticleFromJSON(jsonValue));
    }

    /**
     * Method to fetch multiple specific instances at once. THIS METHOD SHOULD BE REPLACED AT SOME POINT!
     */
    async v1ItemsArticlesBatchRequestRetrieve(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIArticle> {
        const response = await this.v1ItemsArticlesBatchRequestRetrieveRaw(initOverrides);
        return await response.value();
    }

    /**
     * Return all leaf articles (articles with no children) in the BOM tree with their amounts.  This endpoint is useful for displaying BOM articles in request forms where only the leaf articles (actual parts to be manufactured/ordered) need to be shown with their quantities.  Staff users can access BOM leaf articles for any article (needed for viewing requests from other organizations).
     */
    async v1ItemsArticlesBomLeafArticlesRetrieveRaw(requestParameters: V1ItemsArticlesBomLeafArticlesRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIArticle>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1ItemsArticlesBomLeafArticlesRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/items/articles/{id}/bom_leaf_articles/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIArticleFromJSON(jsonValue));
    }

    /**
     * Return all leaf articles (articles with no children) in the BOM tree with their amounts.  This endpoint is useful for displaying BOM articles in request forms where only the leaf articles (actual parts to be manufactured/ordered) need to be shown with their quantities.  Staff users can access BOM leaf articles for any article (needed for viewing requests from other organizations).
     */
    async v1ItemsArticlesBomLeafArticlesRetrieve(requestParameters: V1ItemsArticlesBomLeafArticlesRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIArticle> {
        const response = await this.v1ItemsArticlesBomLeafArticlesRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Return the BOM root article for the specified article.  The BOM root is the topmost ancestor that has is_bom_base=True. Returns 404 if the article is not part of any BOM.  Staff users can access BOM root for any article (needed for viewing requests from other organizations).
     */
    async v1ItemsArticlesBomRootRetrieveRaw(requestParameters: V1ItemsArticlesBomRootRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIArticle>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1ItemsArticlesBomRootRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/items/articles/{id}/bom_root/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIArticleFromJSON(jsonValue));
    }

    /**
     * Return the BOM root article for the specified article.  The BOM root is the topmost ancestor that has is_bom_base=True. Returns 404 if the article is not part of any BOM.  Staff users can access BOM root for any article (needed for viewing requests from other organizations).
     */
    async v1ItemsArticlesBomRootRetrieve(requestParameters: V1ItemsArticlesBomRootRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIArticle> {
        const response = await this.v1ItemsArticlesBomRootRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Return all articles that are direct children to the specified article.
     */
    async v1ItemsArticlesChildrenRetrieveRaw(requestParameters: V1ItemsArticlesChildrenRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIArticle>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1ItemsArticlesChildrenRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/items/articles/{id}/children/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIArticleFromJSON(jsonValue));
    }

    /**
     * Return all articles that are direct children to the specified article.
     */
    async v1ItemsArticlesChildrenRetrieve(requestParameters: V1ItemsArticlesChildrenRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIArticle> {
        const response = await this.v1ItemsArticlesChildrenRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * DEPRECATED! Use the serializer mixin below instead.  We replaced this class with the FieldLevelPermissionMixin for serializers as this mixin required a view to be instantiated to work. Therefore the fields of a serializer could not be filtered when the view was not used, for example when using expandable fields of the SerializerExtensionsMixin.  The new mixin works on the serializer-level and therefore allows to apply field level permissions every time the serializer is instantiated, detached from any view.    Mixin to provide model-field level permissions. For this to work the serializer you use must inherit the \'SerializerExtensionsMixin\'!  How to use:     1. Add the mixin as the first inherited class to your viewset     2. Add the \'model_class\' class attribute and set it to the model class        that your viewset is concerned with.        If your viewset is concerned with multiple models you can define        a \'get_model_class\' method to return the right model in each situation.     3. Define a \'get_forbidden_fields\' classmethod on the according model        classes that returns a list of fieldnames for all fields that a user        is not allowed to view/edit. Example:              @classmethod             def get_forbidden_fields(cls, action: Literal[\"view\", \"create\", \"edit\"],                                      user) -> List[str]:                 if action == \"view\":                     if user.is_staff: return []                      # for all other users                     return [                         \"forbidden_field_name_1\",                         \"forbidden_field_name_2,                     ]                 return []
     */
    async v1ItemsArticlesCreateRaw(requestParameters: V1ItemsArticlesCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIArticle>> {
        if (requestParameters['aPIArticleRequest'] == null) {
            throw new runtime.RequiredError(
                'aPIArticleRequest',
                'Required parameter "aPIArticleRequest" was null or undefined when calling v1ItemsArticlesCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/items/articles/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: APIArticleRequestToJSON(requestParameters['aPIArticleRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIArticleFromJSON(jsonValue));
    }

    /**
     * DEPRECATED! Use the serializer mixin below instead.  We replaced this class with the FieldLevelPermissionMixin for serializers as this mixin required a view to be instantiated to work. Therefore the fields of a serializer could not be filtered when the view was not used, for example when using expandable fields of the SerializerExtensionsMixin.  The new mixin works on the serializer-level and therefore allows to apply field level permissions every time the serializer is instantiated, detached from any view.    Mixin to provide model-field level permissions. For this to work the serializer you use must inherit the \'SerializerExtensionsMixin\'!  How to use:     1. Add the mixin as the first inherited class to your viewset     2. Add the \'model_class\' class attribute and set it to the model class        that your viewset is concerned with.        If your viewset is concerned with multiple models you can define        a \'get_model_class\' method to return the right model in each situation.     3. Define a \'get_forbidden_fields\' classmethod on the according model        classes that returns a list of fieldnames for all fields that a user        is not allowed to view/edit. Example:              @classmethod             def get_forbidden_fields(cls, action: Literal[\"view\", \"create\", \"edit\"],                                      user) -> List[str]:                 if action == \"view\":                     if user.is_staff: return []                      # for all other users                     return [                         \"forbidden_field_name_1\",                         \"forbidden_field_name_2,                     ]                 return []
     */
    async v1ItemsArticlesCreate(requestParameters: V1ItemsArticlesCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIArticle> {
        const response = await this.v1ItemsArticlesCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * DEPRECATED! Use the serializer mixin below instead.  We replaced this class with the FieldLevelPermissionMixin for serializers as this mixin required a view to be instantiated to work. Therefore the fields of a serializer could not be filtered when the view was not used, for example when using expandable fields of the SerializerExtensionsMixin.  The new mixin works on the serializer-level and therefore allows to apply field level permissions every time the serializer is instantiated, detached from any view.    Mixin to provide model-field level permissions. For this to work the serializer you use must inherit the \'SerializerExtensionsMixin\'!  How to use:     1. Add the mixin as the first inherited class to your viewset     2. Add the \'model_class\' class attribute and set it to the model class        that your viewset is concerned with.        If your viewset is concerned with multiple models you can define        a \'get_model_class\' method to return the right model in each situation.     3. Define a \'get_forbidden_fields\' classmethod on the according model        classes that returns a list of fieldnames for all fields that a user        is not allowed to view/edit. Example:              @classmethod             def get_forbidden_fields(cls, action: Literal[\"view\", \"create\", \"edit\"],                                      user) -> List[str]:                 if action == \"view\":                     if user.is_staff: return []                      # for all other users                     return [                         \"forbidden_field_name_1\",                         \"forbidden_field_name_2,                     ]                 return []
     */
    async v1ItemsArticlesDestroyRaw(requestParameters: V1ItemsArticlesDestroyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1ItemsArticlesDestroy().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/items/articles/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * DEPRECATED! Use the serializer mixin below instead.  We replaced this class with the FieldLevelPermissionMixin for serializers as this mixin required a view to be instantiated to work. Therefore the fields of a serializer could not be filtered when the view was not used, for example when using expandable fields of the SerializerExtensionsMixin.  The new mixin works on the serializer-level and therefore allows to apply field level permissions every time the serializer is instantiated, detached from any view.    Mixin to provide model-field level permissions. For this to work the serializer you use must inherit the \'SerializerExtensionsMixin\'!  How to use:     1. Add the mixin as the first inherited class to your viewset     2. Add the \'model_class\' class attribute and set it to the model class        that your viewset is concerned with.        If your viewset is concerned with multiple models you can define        a \'get_model_class\' method to return the right model in each situation.     3. Define a \'get_forbidden_fields\' classmethod on the according model        classes that returns a list of fieldnames for all fields that a user        is not allowed to view/edit. Example:              @classmethod             def get_forbidden_fields(cls, action: Literal[\"view\", \"create\", \"edit\"],                                      user) -> List[str]:                 if action == \"view\":                     if user.is_staff: return []                      # for all other users                     return [                         \"forbidden_field_name_1\",                         \"forbidden_field_name_2,                     ]                 return []
     */
    async v1ItemsArticlesDestroy(requestParameters: V1ItemsArticlesDestroyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.v1ItemsArticlesDestroyRaw(requestParameters, initOverrides);
    }

    /**
     * DEPRECATED! Use the serializer mixin below instead.  We replaced this class with the FieldLevelPermissionMixin for serializers as this mixin required a view to be instantiated to work. Therefore the fields of a serializer could not be filtered when the view was not used, for example when using expandable fields of the SerializerExtensionsMixin.  The new mixin works on the serializer-level and therefore allows to apply field level permissions every time the serializer is instantiated, detached from any view.    Mixin to provide model-field level permissions. For this to work the serializer you use must inherit the \'SerializerExtensionsMixin\'!  How to use:     1. Add the mixin as the first inherited class to your viewset     2. Add the \'model_class\' class attribute and set it to the model class        that your viewset is concerned with.        If your viewset is concerned with multiple models you can define        a \'get_model_class\' method to return the right model in each situation.     3. Define a \'get_forbidden_fields\' classmethod on the according model        classes that returns a list of fieldnames for all fields that a user        is not allowed to view/edit. Example:              @classmethod             def get_forbidden_fields(cls, action: Literal[\"view\", \"create\", \"edit\"],                                      user) -> List[str]:                 if action == \"view\":                     if user.is_staff: return []                      # for all other users                     return [                         \"forbidden_field_name_1\",                         \"forbidden_field_name_2,                     ]                 return []
     */
    async v1ItemsArticlesListRaw(requestParameters: V1ItemsArticlesListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIPaginatedArticleList>> {
        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['page_size'] = requestParameters['pageSize'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/items/articles/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIPaginatedArticleListFromJSON(jsonValue));
    }

    /**
     * DEPRECATED! Use the serializer mixin below instead.  We replaced this class with the FieldLevelPermissionMixin for serializers as this mixin required a view to be instantiated to work. Therefore the fields of a serializer could not be filtered when the view was not used, for example when using expandable fields of the SerializerExtensionsMixin.  The new mixin works on the serializer-level and therefore allows to apply field level permissions every time the serializer is instantiated, detached from any view.    Mixin to provide model-field level permissions. For this to work the serializer you use must inherit the \'SerializerExtensionsMixin\'!  How to use:     1. Add the mixin as the first inherited class to your viewset     2. Add the \'model_class\' class attribute and set it to the model class        that your viewset is concerned with.        If your viewset is concerned with multiple models you can define        a \'get_model_class\' method to return the right model in each situation.     3. Define a \'get_forbidden_fields\' classmethod on the according model        classes that returns a list of fieldnames for all fields that a user        is not allowed to view/edit. Example:              @classmethod             def get_forbidden_fields(cls, action: Literal[\"view\", \"create\", \"edit\"],                                      user) -> List[str]:                 if action == \"view\":                     if user.is_staff: return []                      # for all other users                     return [                         \"forbidden_field_name_1\",                         \"forbidden_field_name_2,                     ]                 return []
     */
    async v1ItemsArticlesList(requestParameters: V1ItemsArticlesListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIPaginatedArticleList> {
        const response = await this.v1ItemsArticlesListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * DEPRECATED! Use the serializer mixin below instead.  We replaced this class with the FieldLevelPermissionMixin for serializers as this mixin required a view to be instantiated to work. Therefore the fields of a serializer could not be filtered when the view was not used, for example when using expandable fields of the SerializerExtensionsMixin.  The new mixin works on the serializer-level and therefore allows to apply field level permissions every time the serializer is instantiated, detached from any view.    Mixin to provide model-field level permissions. For this to work the serializer you use must inherit the \'SerializerExtensionsMixin\'!  How to use:     1. Add the mixin as the first inherited class to your viewset     2. Add the \'model_class\' class attribute and set it to the model class        that your viewset is concerned with.        If your viewset is concerned with multiple models you can define        a \'get_model_class\' method to return the right model in each situation.     3. Define a \'get_forbidden_fields\' classmethod on the according model        classes that returns a list of fieldnames for all fields that a user        is not allowed to view/edit. Example:              @classmethod             def get_forbidden_fields(cls, action: Literal[\"view\", \"create\", \"edit\"],                                      user) -> List[str]:                 if action == \"view\":                     if user.is_staff: return []                      # for all other users                     return [                         \"forbidden_field_name_1\",                         \"forbidden_field_name_2,                     ]                 return []
     */
    async v1ItemsArticlesPartialUpdateRaw(requestParameters: V1ItemsArticlesPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIArticle>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1ItemsArticlesPartialUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/items/articles/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: APIPatchedArticleRequestToJSON(requestParameters['aPIPatchedArticleRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIArticleFromJSON(jsonValue));
    }

    /**
     * DEPRECATED! Use the serializer mixin below instead.  We replaced this class with the FieldLevelPermissionMixin for serializers as this mixin required a view to be instantiated to work. Therefore the fields of a serializer could not be filtered when the view was not used, for example when using expandable fields of the SerializerExtensionsMixin.  The new mixin works on the serializer-level and therefore allows to apply field level permissions every time the serializer is instantiated, detached from any view.    Mixin to provide model-field level permissions. For this to work the serializer you use must inherit the \'SerializerExtensionsMixin\'!  How to use:     1. Add the mixin as the first inherited class to your viewset     2. Add the \'model_class\' class attribute and set it to the model class        that your viewset is concerned with.        If your viewset is concerned with multiple models you can define        a \'get_model_class\' method to return the right model in each situation.     3. Define a \'get_forbidden_fields\' classmethod on the according model        classes that returns a list of fieldnames for all fields that a user        is not allowed to view/edit. Example:              @classmethod             def get_forbidden_fields(cls, action: Literal[\"view\", \"create\", \"edit\"],                                      user) -> List[str]:                 if action == \"view\":                     if user.is_staff: return []                      # for all other users                     return [                         \"forbidden_field_name_1\",                         \"forbidden_field_name_2,                     ]                 return []
     */
    async v1ItemsArticlesPartialUpdate(requestParameters: V1ItemsArticlesPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIArticle> {
        const response = await this.v1ItemsArticlesPartialUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * DEPRECATED! Use the serializer mixin below instead.  We replaced this class with the FieldLevelPermissionMixin for serializers as this mixin required a view to be instantiated to work. Therefore the fields of a serializer could not be filtered when the view was not used, for example when using expandable fields of the SerializerExtensionsMixin.  The new mixin works on the serializer-level and therefore allows to apply field level permissions every time the serializer is instantiated, detached from any view.    Mixin to provide model-field level permissions. For this to work the serializer you use must inherit the \'SerializerExtensionsMixin\'!  How to use:     1. Add the mixin as the first inherited class to your viewset     2. Add the \'model_class\' class attribute and set it to the model class        that your viewset is concerned with.        If your viewset is concerned with multiple models you can define        a \'get_model_class\' method to return the right model in each situation.     3. Define a \'get_forbidden_fields\' classmethod on the according model        classes that returns a list of fieldnames for all fields that a user        is not allowed to view/edit. Example:              @classmethod             def get_forbidden_fields(cls, action: Literal[\"view\", \"create\", \"edit\"],                                      user) -> List[str]:                 if action == \"view\":                     if user.is_staff: return []                      # for all other users                     return [                         \"forbidden_field_name_1\",                         \"forbidden_field_name_2,                     ]                 return []
     */
    async v1ItemsArticlesRetrieveRaw(requestParameters: V1ItemsArticlesRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIArticle>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1ItemsArticlesRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/items/articles/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIArticleFromJSON(jsonValue));
    }

    /**
     * DEPRECATED! Use the serializer mixin below instead.  We replaced this class with the FieldLevelPermissionMixin for serializers as this mixin required a view to be instantiated to work. Therefore the fields of a serializer could not be filtered when the view was not used, for example when using expandable fields of the SerializerExtensionsMixin.  The new mixin works on the serializer-level and therefore allows to apply field level permissions every time the serializer is instantiated, detached from any view.    Mixin to provide model-field level permissions. For this to work the serializer you use must inherit the \'SerializerExtensionsMixin\'!  How to use:     1. Add the mixin as the first inherited class to your viewset     2. Add the \'model_class\' class attribute and set it to the model class        that your viewset is concerned with.        If your viewset is concerned with multiple models you can define        a \'get_model_class\' method to return the right model in each situation.     3. Define a \'get_forbidden_fields\' classmethod on the according model        classes that returns a list of fieldnames for all fields that a user        is not allowed to view/edit. Example:              @classmethod             def get_forbidden_fields(cls, action: Literal[\"view\", \"create\", \"edit\"],                                      user) -> List[str]:                 if action == \"view\":                     if user.is_staff: return []                      # for all other users                     return [                         \"forbidden_field_name_1\",                         \"forbidden_field_name_2,                     ]                 return []
     */
    async v1ItemsArticlesRetrieve(requestParameters: V1ItemsArticlesRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIArticle> {
        const response = await this.v1ItemsArticlesRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * return all StorageArticles that refer to the article where the primary key is equal to pk
     */
    async v1ItemsArticlesStorageInfoRetrieveRaw(requestParameters: V1ItemsArticlesStorageInfoRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIStorageArticle>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1ItemsArticlesStorageInfoRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/items/articles/{id}/storage_info/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIStorageArticleFromJSON(jsonValue));
    }

    /**
     * return all StorageArticles that refer to the article where the primary key is equal to pk
     */
    async v1ItemsArticlesStorageInfoRetrieve(requestParameters: V1ItemsArticlesStorageInfoRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIStorageArticle> {
        const response = await this.v1ItemsArticlesStorageInfoRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * DEPRECATED! Use the serializer mixin below instead.  We replaced this class with the FieldLevelPermissionMixin for serializers as this mixin required a view to be instantiated to work. Therefore the fields of a serializer could not be filtered when the view was not used, for example when using expandable fields of the SerializerExtensionsMixin.  The new mixin works on the serializer-level and therefore allows to apply field level permissions every time the serializer is instantiated, detached from any view.    Mixin to provide model-field level permissions. For this to work the serializer you use must inherit the \'SerializerExtensionsMixin\'!  How to use:     1. Add the mixin as the first inherited class to your viewset     2. Add the \'model_class\' class attribute and set it to the model class        that your viewset is concerned with.        If your viewset is concerned with multiple models you can define        a \'get_model_class\' method to return the right model in each situation.     3. Define a \'get_forbidden_fields\' classmethod on the according model        classes that returns a list of fieldnames for all fields that a user        is not allowed to view/edit. Example:              @classmethod             def get_forbidden_fields(cls, action: Literal[\"view\", \"create\", \"edit\"],                                      user) -> List[str]:                 if action == \"view\":                     if user.is_staff: return []                      # for all other users                     return [                         \"forbidden_field_name_1\",                         \"forbidden_field_name_2,                     ]                 return []
     */
    async v1ItemsArticlesUpdateRaw(requestParameters: V1ItemsArticlesUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIArticle>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1ItemsArticlesUpdate().'
            );
        }

        if (requestParameters['aPIArticleRequest'] == null) {
            throw new runtime.RequiredError(
                'aPIArticleRequest',
                'Required parameter "aPIArticleRequest" was null or undefined when calling v1ItemsArticlesUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/items/articles/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: APIArticleRequestToJSON(requestParameters['aPIArticleRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIArticleFromJSON(jsonValue));
    }

    /**
     * DEPRECATED! Use the serializer mixin below instead.  We replaced this class with the FieldLevelPermissionMixin for serializers as this mixin required a view to be instantiated to work. Therefore the fields of a serializer could not be filtered when the view was not used, for example when using expandable fields of the SerializerExtensionsMixin.  The new mixin works on the serializer-level and therefore allows to apply field level permissions every time the serializer is instantiated, detached from any view.    Mixin to provide model-field level permissions. For this to work the serializer you use must inherit the \'SerializerExtensionsMixin\'!  How to use:     1. Add the mixin as the first inherited class to your viewset     2. Add the \'model_class\' class attribute and set it to the model class        that your viewset is concerned with.        If your viewset is concerned with multiple models you can define        a \'get_model_class\' method to return the right model in each situation.     3. Define a \'get_forbidden_fields\' classmethod on the according model        classes that returns a list of fieldnames for all fields that a user        is not allowed to view/edit. Example:              @classmethod             def get_forbidden_fields(cls, action: Literal[\"view\", \"create\", \"edit\"],                                      user) -> List[str]:                 if action == \"view\":                     if user.is_staff: return []                      # for all other users                     return [                         \"forbidden_field_name_1\",                         \"forbidden_field_name_2,                     ]                 return []
     */
    async v1ItemsArticlesUpdate(requestParameters: V1ItemsArticlesUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIArticle> {
        const response = await this.v1ItemsArticlesUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Export all (non-nested) article-data into a CSV file.
     */
    async v1ItemsExportArticlesListRaw(requestParameters: V1ItemsExportArticlesListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIPaginatedArticleExportList>> {
        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['page_size'] = requestParameters['pageSize'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/items/export_articles/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIPaginatedArticleExportListFromJSON(jsonValue));
    }

    /**
     * Export all (non-nested) article-data into a CSV file.
     */
    async v1ItemsExportArticlesList(requestParameters: V1ItemsExportArticlesListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIPaginatedArticleExportList> {
        const response = await this.v1ItemsExportArticlesListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * A create view that enables importing article data from a CSV file.
     */
    async v1ItemsImportArticlesCreateRaw(requestParameters: V1ItemsImportArticlesCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIArticle>> {
        if (requestParameters['number'] == null) {
            throw new runtime.RequiredError(
                'number',
                'Required parameter "number" was null or undefined when calling v1ItemsImportArticlesCreate().'
            );
        }

        if (requestParameters['material'] == null) {
            throw new runtime.RequiredError(
                'material',
                'Required parameter "material" was null or undefined when calling v1ItemsImportArticlesCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
            { contentType: 'application/x-www-form-urlencoded' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['name'] != null) {
            formParams.append('name', requestParameters['name'] as any);
        }

        if (requestParameters['number'] != null) {
            formParams.append('number', requestParameters['number'] as any);
        }

        if (requestParameters['hoopsPartId'] != null) {
            formParams.append('hoops_part_id', requestParameters['hoopsPartId'] as any);
        }

        if (requestParameters['weight'] != null) {
            formParams.append('weight', new Blob([JSON.stringify(APIMeasurementRequestToJSON(requestParameters['weight']))], { type: "application/json", }));
        }

        if (requestParameters['length'] != null) {
            formParams.append('length', new Blob([JSON.stringify(APIMeasurementRequestToJSON(requestParameters['length']))], { type: "application/json", }));
        }

        if (requestParameters['width'] != null) {
            formParams.append('width', new Blob([JSON.stringify(APIMeasurementRequestToJSON(requestParameters['width']))], { type: "application/json", }));
        }

        if (requestParameters['height'] != null) {
            formParams.append('height', new Blob([JSON.stringify(APIMeasurementRequestToJSON(requestParameters['height']))], { type: "application/json", }));
        }

        if (requestParameters['volume'] != null) {
            formParams.append('volume', new Blob([JSON.stringify(APIMeasurementRequestToJSON(requestParameters['volume']))], { type: "application/json", }));
        }

        if (requestParameters['barcodeText'] != null) {
            formParams.append('barcode_text', requestParameters['barcodeText'] as any);
        }

        if (requestParameters['qualityClass'] != null) {
            formParams.append('quality_class', requestParameters['qualityClass'] as any);
        }

        if (requestParameters['countryOfOrigin'] != null) {
            formParams.append('country_of_origin', requestParameters['countryOfOrigin'] as any);
        }

        if (requestParameters['description'] != null) {
            formParams.append('description', requestParameters['description'] as any);
        }

        if (requestParameters['leadTime'] != null) {
            formParams.append('lead_time', new Blob([JSON.stringify(APIHumanReadableDurationRequestToJSON(requestParameters['leadTime']))], { type: "application/json", }));
        }

        if (requestParameters['isBomBase'] != null) {
            formParams.append('is_bom_base', requestParameters['isBomBase'] as any);
        }

        if (requestParameters['isImportedVersion'] != null) {
            formParams.append('is_imported_version', requestParameters['isImportedVersion'] as any);
        }

        if (requestParameters['articleType'] != null) {
            formParams.append('article_type', requestParameters['articleType'] as any);
        }

        if (requestParameters['family'] != null) {
            formParams.append('family', requestParameters['family'] as any);
        }

        if (requestParameters['brand'] != null) {
            formParams.append('brand', requestParameters['brand'] as any);
        }

        if (requestParameters['barcodeType'] != null) {
            formParams.append('barcode_type', requestParameters['barcodeType'] as any);
        }

        if (requestParameters['material'] != null) {
            formParams.append('material', requestParameters['material'] as any);
        }

        if (requestParameters['variationOf'] != null) {
            formParams.append('variation_of', requestParameters['variationOf'] as any);
        }

        if (requestParameters['supplier'] != null) {
            formParams.append('supplier', requestParameters['supplier'] as any);
        }

        if (requestParameters['category'] != null) {
            formParams.append('category', requestParameters['category']!.join(runtime.COLLECTION_FORMATS["csv"]));
        }

        if (requestParameters['properties'] != null) {
            formParams.append('properties', requestParameters['properties']!.join(runtime.COLLECTION_FORMATS["csv"]));
        }

        if (requestParameters['guestRequest'] != null) {
            formParams.append('guest_request', requestParameters['guestRequest'] as any);
        }

        if (requestParameters['sharedRequest'] != null) {
            formParams.append('shared_request', requestParameters['sharedRequest'] as any);
        }

        const response = await this.request({
            path: `/v1/items/import_articles/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIArticleFromJSON(jsonValue));
    }

    /**
     * A create view that enables importing article data from a CSV file.
     */
    async v1ItemsImportArticlesCreate(requestParameters: V1ItemsImportArticlesCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIArticle> {
        const response = await this.v1ItemsImportArticlesCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * A create view that enables undoing an article-import by reverting all overwritten articles to their respective pre-import versions and deleting all articles that were created by the import view.
     */
    async v1ItemsUndoImportArticlesCreateRaw(requestParameters: V1ItemsUndoImportArticlesCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIArticleExport>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/items/undo_import_articles/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: APIArticleExportRequestToJSON(requestParameters['aPIArticleExportRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIArticleExportFromJSON(jsonValue));
    }

    /**
     * A create view that enables undoing an article-import by reverting all overwritten articles to their respective pre-import versions and deleting all articles that were created by the import view.
     */
    async v1ItemsUndoImportArticlesCreate(requestParameters: V1ItemsUndoImportArticlesCreateRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIArticleExport> {
        const response = await this.v1ItemsUndoImportArticlesCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
